import { render, staticRenderFns } from "./QuotaStatement.vue?vue&type=template&id=461d8392"
import script from "./QuotaStatement.vue?vue&type=script&lang=js"
export * from "./QuotaStatement.vue?vue&type=script&lang=js"
import style0 from "./QuotaStatement.vue?vue&type=style&index=0&id=461d8392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports